import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';

import { TranslateModule } from '@ngx-translate/core';

import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';

import { VideoPlaybackSettingsMenuComponent } from './VideoPlaybackSettingsMenu.Component';

@NgModule({
	imports: [
		CommonModule,
		SecurityAngularModule,
		VbDropdownMenuModule,
		TranslateModule,
		DialogAngularModule,
		UIRouterModule
	],
	declarations: [
		VideoPlaybackSettingsMenuComponent
	],
	exports: [
		VideoPlaybackSettingsMenuComponent
	]
})
export class VideoPlaybackSettingsMenuModule {}
